module.exports = __webpack_public_path__ + "img/yamaguchi.a4bbdb36.jpg";